/* Hauchklar – echter Shopify-Warenkorb fuer den Nachbau (Minimog-Optik).
   Pakete waehlen (Formel-Karten, Ziehoel-Kaufbox), In den Warenkorb (/cart/add.js), Drawer live (Section-Rendering),
   Menge/Entfernen ueber den Zeilen-Schluessel (/cart/change.js mit id = item.key), Zur Kasse = Shopify-Checkout.
   Erzeugt von atemklar/shopify/_port (Fixes 22.10.: Schluessel statt Position, gemeinsame Sperre gegen Doppelklick;
   23.10.: Hauchklar-Titel/-Bild/-Paket als versteckte Positions-Eigenschaften). */
(function () {
  'use strict';
  var CFG = window.AK || {};
  var SECTION = CFG.section || 'atemklar-cart-drawer';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var url = function (k, f) { return (window.routes && routes[k]) || f; };
  var laeuft = false; /* gemeinsame Sperre: immer nur eine Warenkorb-Aenderung gleichzeitig */

  function drawer() { return $('m-cart-drawer'); }
  function oeffnen() {
    var d = drawer(); if (!d) return;
    d.classList.add('m-cart-drawer--active');
    d.style.setProperty('--cart-drawer-overlay-alpha', '0');
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      d.style.setProperty('--cart-drawer-inner-translate-x', '0');
      d.style.setProperty('--cart-drawer-overlay-alpha', '0.5');
    }); });
    document.documentElement.style.overflow = 'hidden';
  }
  function schliessen() {
    var d = drawer(); if (!d) return;
    d.style.setProperty('--cart-drawer-inner-translate-x', '100%');
    d.style.setProperty('--cart-drawer-overlay-alpha', '0');
    setTimeout(function () { d.classList.remove('m-cart-drawer--active'); document.documentElement.style.overflow = ''; }, 300);
  }
  function zaehler(n) {
    $$('[data-ak-count]').forEach(function (e) { e.textContent = n; e.classList.toggle('hidden', !n); });
  }
  function rendern(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var neu = doc.querySelector('m-cart-drawer'), d = drawer();
    if (neu && d) {
      var aktiv = d.classList.contains('m-cart-drawer--active');
      d.innerHTML = neu.innerHTML;
      d.className = neu.className + (aktiv ? ' m-cart-drawer--active' : '');
    }
  }
  function korbZahl() {
    return fetch(url('cart_url', '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) {
        var n = c.item_count; (c.items || []).forEach(function (i) { if (i.variant_id === Number(CFG.schutz || 0)) n -= i.quantity; });
        zaehler(n); return c; });
  }
  function senden(pfad, daten) {
    daten.sections = [SECTION];
    daten.sections_url = window.location.pathname + window.location.search;
    return fetch(pfad, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(daten) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status && res.status >= 400) throw new Error(res.description || res.message || 'Fehler');
        if (res && res.sections) rendern(res.sections[SECTION]);
        return korbZahl();
      });
  }
  function variante(seite, i) {
    var eigene = (CFG.varianten && CFG.varianten[seite]) || [];
    var v = (eigene[i] || '').trim();
    if (v) return Number(v);
    var ersatz = CFG.ersatz || [];
    return Number(ersatz[i] || ersatz[0] || 0);
  }
  /* Fix 23.10.: versteckte Eigenschaften (Unterstrich = im Checkout unsichtbar), damit Drawer und Warenkorb-Seite
     Hauchklar-Titel, -Bild und -Paket zeigen, auch wenn der Produktname im Shop abweicht. */
  function merkmale(seite, i) {
    var p = (CFG.hk && CFG.hk[seite]) || null;
    if (!p) return null;
    var m = { _hk_seite: seite, _hk_titel: p.titel || '', _hk_bild: p.bild || '', _hk_paket: (p.pakete && p.pakete[i]) || '' };
    var d = CFG.dosen && CFG.dosen[seite]; if (d && d[i]) m._hk_dosen = String(d[i]);
    return m;
  }
  function hinzufuegen(i, knopf) {
    var id = variante(CFG.seite, i);
    if (!id || laeuft) return;
    laeuft = true;
    if (knopf) { knopf.setAttribute('aria-busy', 'true'); knopf.style.opacity = '.7'; }
    var pos = { id: id, quantity: 1 }, m = merkmale(CFG.seite, i);
    if (m) pos.properties = m;
    /* 28.10. Abo (Kaching-Verkaufsplan): nur wenn auf der Seite "Abo" gewaehlt ist */
    var plan = window.AKAbo && window.AKAbo.plan();
    if (plan) pos.selling_plan = plan;
    senden(url('cart_add_url', '/cart/add') + '.js', { items: [pos] })
      .then(schutzPruefen)
      .then(function () { oeffnen(); })
      .catch(function (e) { console.error('Hauchklar Warenkorb', e); alert('Das Paket konnte nicht in den Warenkorb gelegt werden. Bitte versuch es noch einmal.'); })
      .then(function () { laeuft = false; if (knopf) { knopf.removeAttribute('aria-busy'); knopf.style.opacity = ''; } });
  }

  /* ---- 23.10. Versandschutz (5 €, automatisch dabei, abwaehlbar; Abwahl merkt sich das Warenkorb-Attribut hk_versandschutz=aus) ---- */
  var SCHUTZ = Number(CFG.schutz || 0);
  function schutzPruefen(c) {
    if (!SCHUTZ) return Promise.resolve(c);
    var p = c ? Promise.resolve(c) : fetch(url('cart_url', '/cart') + '.js').then(function (r) { return r.json(); });
    return p.then(function (c) {
      var s = null, andere = 0;
      (c.items || []).forEach(function (i) { if (i.variant_id === SCHUTZ) s = i; else andere += i.quantity; });
      var aus = c.attributes && c.attributes.hk_versandschutz === 'aus';
      if (andere > 0 && !s && !aus) return senden(url('cart_add_url', '/cart/add') + '.js', { items: [{ id: SCHUTZ, quantity: 1 }] });
      if (s && (andere === 0 || aus)) return senden(url('cart_change_url', '/cart/change') + '.js', { id: s.key, quantity: 0 });
      if (s && s.quantity !== 1) return senden(url('cart_change_url', '/cart/change') + '.js', { id: s.key, quantity: 1 });
      return c;
    }).catch(function (e) { console.warn('Hauchklar Versandschutz nicht verfügbar', e); return c; });
  }
  document.addEventListener('change', function (e) {
    var cb = e.target.closest && e.target.closest('[data-ak-schutz]');
    if (!cb || laeuft) return;
    laeuft = true;
    senden(url('cart_update_url', '/cart/update') + '.js', { attributes: { hk_versandschutz: cb.checked ? 'an' : 'aus' } })
      .then(schutzPruefen)
      .catch(function (err) { console.error('Hauchklar Versandschutz', err); })
      .then(function () { laeuft = false; });
  });
  /* ---- 23.10. Upsell in der Schublade (Ziehoel) ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ak-upsell]');
    if (!b || laeuft) return;
    e.preventDefault(); laeuft = true; b.setAttribute('aria-busy', 'true'); b.style.opacity = '.7';
    var eigene = (CFG.varianten && CFG.varianten.ziehoel && CFG.varianten.ziehoel[0] || '').trim();
    var pos = { id: Number(eigene || b.getAttribute('data-ak-upsell')), quantity: 1 }, m = merkmale('ziehoel', 0);
    if (m) pos.properties = m;
    senden(url('cart_add_url', '/cart/add') + '.js', { items: [pos] })
      .then(schutzPruefen)
      .catch(function (err) { console.error('Hauchklar Upsell', err); })
      .then(function () { laeuft = false; });
  }, true);

  /* ---- Formel-Kaufbox (Karten + Knopf mit Preis) ---- */
  var karten = $$('.nouri-bundle-card');
  karten.forEach(function (k) {
    k.style.cursor = 'pointer';
    k.addEventListener('click', function () {
      karten.forEach(function (x) { x.classList.toggle('selected', x === k); });
      var p = $('.nouri-bundle-price', k), ziel = $('#nouriAtcPrice');
      if (p && ziel) ziel.textContent = p.textContent;
    });
  });
  var atc = $('#nouriAtc');
  if (atc) atc.addEventListener('click', function (e) {
    e.preventDefault(); e.stopImmediatePropagation();
    var sel = $('.nouri-bundle-card.selected') || karten[0];
    hinzufuegen(sel ? (parseInt(sel.getAttribute('data-bundle'), 10) || 0) : 0, atc);
  }, true);

  /* ---- 28.10. Abo-Schalter (Einmalkauf / Abo -20 %, Lieferung jeden Monat oder alle 3 Monate) ---- */
  (function () {
    var box = $('#akAbo'), D = window.AK_ABO;
    if (!box || !D || !D.plaene || !D.plaene.length || !karten.length) return;
    var TAGE = [30, 90, 150];
    var euro = function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; };
    var aktiv = false, plan = null, gewaehlt = false;
    var opts = $$('[data-ak-kauf]', box), int = $('.ak-abo-int', box), btns = $('.ak-abo-int-btns', box);
    var original = karten.map(function (k) { var r = $('.nouri-bundle-right', k); return r ? r.innerHTML : ''; });
    var spar = karten.map(function (k) { var s = $('.nouri-bundle-save', k); return s ? s.textContent : null; });
    var zahl = function (s) { return Math.round(parseFloat(String(s).replace(/[^0-9,]/g, '').replace(',', '.')) * 100) || 0; };
    function kurz(n) { return String(n).split('|')[0].replace(/^Lieferung\s*/i, '').trim().replace(/^./, function (c) { return c.toUpperCase(); }); }
    function dreiMonate(p) { return /3 Monat/.test(p.name); }
    D.plaene.forEach(function (p) {
      var b = document.createElement('button');
      b.type = 'button'; b.setAttribute('role', 'radio'); b.setAttribute('data-ak-plan', p.id); b.textContent = kurz(p.name);
      b.addEventListener('click', function () { gewaehlt = true; setzePlan(p.id); });
      btns.appendChild(b);
    });
    function index() { var s = $('.nouri-bundle-card.selected') || karten[0]; return parseInt(s.getAttribute('data-bundle'), 10) || 0; }
    function standardPlan() {
      var p = index() === 0 ? D.plaene.filter(function (x) { return !dreiMonate(x); })[0] : D.plaene.filter(dreiMonate)[0];
      return (p || D.plaene[0]).id;
    }
    function setzePlan(id) {
      plan = id;
      $$('[data-ak-plan]', btns).forEach(function (b) { var an = String(b.getAttribute('data-ak-plan')) === String(id); b.classList.toggle('is-aktiv', an); b.setAttribute('aria-checked', an ? 'true' : 'false'); });
      preise();
    }
    function preise() {
      karten.forEach(function (k, i) {
        var r = $('.nouri-bundle-right', k); if (!r) return;
        var vid = String((CFG.varianten && CFG.varianten.pdp && CFG.varianten.pdp[i]) || '').trim();
        var cent = aktiv && plan && D.preise[vid] ? D.preise[vid][String(plan)] : null;
        var sp = $('.nouri-bundle-save', k);
        if (sp && spar[i] !== null) sp.textContent = spar[i];
        if (!cent) { r.innerHTML = original[i]; return; }
        r.innerHTML = original[i];
        var pr = $('.nouri-bundle-price', r), cmp = $('.nouri-bundle-compare', r), tag = $('.nouri-bundle-perday', r);
        var alt = pr ? pr.textContent : '';
        if (pr) pr.textContent = euro(cent);
        if (!cmp && pr) { cmp = document.createElement('span'); cmp.className = 'nouri-bundle-compare'; pr.parentNode.insertBefore(cmp, pr.nextSibling); cmp.textContent = alt; }
        if (tag) tag.textContent = euro(Math.round(cent / (TAGE[i] || 30))) + '/Tag';
        var basis = zahl(cmp ? cmp.textContent : alt);
        if (sp && basis > cent) sp.textContent = 'Du sparst ' + Math.round((1 - cent / basis) * 100) + ' %';
      });
      var s = $('.nouri-bundle-card.selected') || karten[0], p = $('.nouri-bundle-price', s), z = $('#nouriAtcPrice');
      if (p && z) z.textContent = p.textContent;
    }
    function setzeKauf(abo) {
      aktiv = abo;
      opts.forEach(function (o) { var an = (o.getAttribute('data-ak-kauf') === 'abo') === abo; o.classList.toggle('is-aktiv', an); o.setAttribute('aria-checked', an ? 'true' : 'false'); });
      int.hidden = !abo;
      if (abo) setzePlan(plan && gewaehlt ? plan : standardPlan()); else preise();
    }
    opts.forEach(function (o) { o.addEventListener('click', function () { setzeKauf(o.getAttribute('data-ak-kauf') === 'abo'); }); });
    karten.forEach(function (k) { k.addEventListener('click', function () { if (aktiv && !gewaehlt) setzePlan(standardPlan()); else preise(); }); });
    box.hidden = false;
    window.AKAbo = { plan: function () { return aktiv ? plan : null; } };
  })();

  /* ---- Ziehoel-Kaufbox (Radio-Pakete + Formular) ---- */
  $$('form[data-ak-box]').forEach(function (f) {
    var box = f.closest('.nrs-bb') || f;
    var pakete = $$('.nrs-bb__bundle', f);
    function waehlen(l) {
      pakete.forEach(function (x) { x.classList.toggle('is-selected', x === l); var r = $('input[type=radio]', x); if (r) r.checked = x === l; });
      var set = function (sel, t) { $$(sel, box).forEach(function (e) { e.textContent = t; }); };
      set('[data-nrs-price]', l.getAttribute('data-price'));
      set('[data-nrs-compare]', l.getAttribute('data-compare'));
      var spar = l.getAttribute('data-save');
      set('[data-nrs-badge]', spar ? 'ANGEBOT: Spare ' + spar : '');
      $$('[data-nrs-badge]', box).forEach(function (e) { e.style.display = spar ? '' : 'none'; });
      set('[data-nrs-atcprice]', l.getAttribute('data-price'));
      set('[data-nrs-atccompare]', l.getAttribute('data-compare'));
    }
    pakete.forEach(function (l) { l.addEventListener('click', function () { waehlen(l); }); });
    f.addEventListener('submit', function (e) {
      e.preventDefault(); e.stopImmediatePropagation();
      var sel = $('.nrs-bb__bundle.is-selected', f) || pakete[pakete.length - 1];
      hinzufuegen(Math.max(0, pakete.indexOf(sel)), $('.nrs-bb__atc', f));
    }, true);
  });

  /* ---- Drawer + Warenkorb-Seite: Menge, Entfernen, Schliessen ---- */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-ak-key][data-ak-qty]');
    if (q) {
      e.preventDefault();
      if (laeuft) return; /* Doppelklick / zweite Aenderung waehrend die erste laeuft */
      laeuft = true;
      var seite = !!q.closest('#MinimogCart');
      q.setAttribute('aria-busy', 'true');
      var key = q.getAttribute('data-ak-key'), menge = Math.max(0, Number(q.getAttribute('data-ak-qty')));
      var istSchutz = SCHUTZ && String(key).split(':')[0] === String(SCHUTZ);
      (istSchutz ? senden(url('cart_update_url', '/cart/update') + '.js', { attributes: { hk_versandschutz: menge ? 'an' : 'aus' } }) : Promise.resolve())
      .then(function () { return senden(url('cart_change_url', '/cart/change') + '.js', { id: key, quantity: istSchutz ? Math.min(menge, 1) : menge }); })
        .then(function (c) { return schutzPruefen(c); })
        .then(function () { if (seite) window.location.reload(); else laeuft = false; })
        .catch(function (err) { console.error('Hauchklar Warenkorb', err); laeuft = false; q.removeAttribute('aria-busy'); });
      return;
    }
    if (e.target.closest('m-cart-drawer .m-cart-drawer--close-icon') || (e.target.classList && (e.target.classList.contains('m-cart--overlay') || e.target.classList.contains('scd__wrapper')))) {
      schliessen();
    }
  });
  window.AKWarenkorb = { oeffnen: oeffnen, schliessen: schliessen, hinzufuegen: hinzufuegen, schutzPruefen: schutzPruefen };
  /* beim Laden: Warenkorb mit Produkten, aber ohne Schutz (oder nur Schutz) -> angleichen */
  if (SCHUTZ) korbZahl().then(function (c) { if (c && c.item_count) return schutzPruefen(c); }).catch(function () {});
})();
